/* eslint-disable eqeqeq */
import React, { useState, useLayoutEffect, useEffect } from "react";

/** Component */
import { Button, TablePagination, Paper, TextField, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TableFooter, Collapse, ButtonGroup, Dialog, Typography } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";

import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
/** Icon */
import SearchIcon from "@mui/icons-material/Search";

/** Api && Function */
import { getLog } from "./../../../services/api";
import { convertQueryStringToObject } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";
import moment from "moment";

/** Hook */
import { API_ACTIONS } from "../../config";

import { useParamFilter } from "../../commons/customHook";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";

export default function LogERP() {
  const [t] = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);

  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50, object: "TO_ERP" }, getLog);
  const filter = convertQueryStringToObject(location.search);

  const [selectedItem, setSelectedItem] = useState(null);
  const [input, setInput] = useState({
    start_date: filter.start_date,
    end_date: filter.end_date,
    email: filter.email,
    content: null,
  });
  // state
  const handleSearch = () => {
    fetchData((prev) => ({ ...input }));
  };

  /** Set Header Title */
  useEffect(() => {
    dispatch(setHeaderTitle("LOG GIAO DỊCH VỚI HỆ THỐNG ERP"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <SearchIcon />
          </Button>
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen}>
          <TextField
            label={t("Email")}
            value={input.email || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, email: e.target.value }))}
            style={{ margin: "5px" }}
            InputLabelProps={{ shrink: true }}
            InputProps={{ style: { minWidth: "200px" } }}
          />
          <TextField
            label={t("Nội dung")}
            value={input.content || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, content: e.target.value }))}
            style={{ margin: "5px" }}
            InputLabelProps={{ shrink: true }}
            InputProps={{ style: { minWidth: "200px" } }}
          />
          <CustomDatePicker label={t("Ngày bắt đầu")} value={input.start_date} onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <CustomDatePicker label={t("Ngày kết thúc")} value={input.end_date} onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <FilterBy
            style={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
            label={t("Trạng thái")}
            getOptionLabel={(option) => option}
            isOptionEqualToValue={(option, value) => option == value}
            getDataFunc={() => Promise.resolve({ data: API_ACTIONS, code: 200 })}
            value={input.action}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, action: newValue }))}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, action: option.find((item) => item == filter.action) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.action]}
          />

          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      ID
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("API")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      Người thực hiện
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center">
                      Dữ liệu gửi đi
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      Dữ liệu nhận về
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      Thời gian thực hiện
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow key={index} onClick={() => setSelectedItem(item)} hover style={{ cursor: "pointer" }}>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.action}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.user}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray", textDecoration: "underline" }} align="center">
                          Xem chi tiết
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          <pre>{item.response}</pre>
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.created_at && moment(item.created_at).format("DD/MM/YYYY")}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
      <Detail onClose={() => setSelectedItem(null)} open={Boolean(selectedItem)} item={selectedItem} />
    </div>
  );
}
const Detail = ({ onClose, open, item }) => {
  if (item)
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" style={{ wordWrap: "break-word" }}>
        <div style={{ padding: 10 }}>
          <Typography variant="subtitle1" gutterBottom>
            Dữ liệu gửi đi
          </Typography>
          <hr />
          <Typography variant="subtitle2" gutterBottom>
            {item.data}
          </Typography>
          <hr />
          <Typography variant="subtitle2" gutterBottom>
            Dữ liệu nhận về
          </Typography>
          <hr />
          <Typography variant="subtitle2" gutterBottom>
            {item.response}
          </Typography>
        </div>
      </Dialog>
    );
  return "";
};
